import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Button, Input, message
} from 'components/common'
import { callGetApiWithAuth } from 'utils/api'
import { Wrapper } from './SearchBar.styled'
import { ReactComponent as SearchOutlinedIcon } from "assets/icons/search-icon.svg";

export default function SearchBar( props ) {
  const dispatch = useDispatch()
  const myUser = useSelector(state=>state.auth.user)
  const treeType = useSelector(state=>state.binaryTree.treeType)
  const [searchInput, setSearchInput] = useState('')
  const [downlines, setDownlines] = useState([])
  
  const onChangeSearch = (e) => {
    setSearchInput(e.target.value)
    if (e.target.value!='') {
      searchDownline(e.target.value)
    }
  }
  const handleSearch = (userInput) => {
    if (!userInput) {
      message.error('Input user ID')
      return 
    }
    if (isNaN(userInput)) {
      message.error('Input ID as number')
      return 
    }
    setDownlines([])
    props.search(userInput)
  }
  const searchDownline = (q) => {
    if (!q) return
    if (treeType=='unilevel')
      callGetApiWithAuth(`common/search_enroll_downline/${q}`, onGetDownlines)
    if (treeType=='placement')
      callGetApiWithAuth(`common/search_placement_downline/${q}`, onGetDownlines)
  }
  const onGetDownlines = (res) => {
    setDownlines(res.data)
  }
  const loadRoot = () => {
    setDownlines([])
    props.loadRoot()
  }
  const loadParent = () => {
    setDownlines([])
    props.loadParent()
  }

  return (
    <Wrapper>
      <div className={'searchRoot'}>
        <Input 
          value={searchInput}
          onChange={onChangeSearch}
          className={'searchInput'}
          label="Search by ID or Username"
          inputPrefix={<SearchOutlinedIcon />}
        />
        {downlines.length>0 &&
          <ul className={'searchResults'}>
            {downlines.map((user, index)=>(
              <li key={index} onClick={()=>handleSearch(user.id)}>
                {`${user.first_name} ${user.last_name}`}
              </li>
            ))}
          </ul>
        }
        <div style={{display:'flex', gap:'10px', height:'100%'}}>
          <Button size="large" className={`searchBtn_Top`}
            onClick={loadRoot}
          >
            Top
          </Button>
          <Button size="large" border bgColor="#fff" color= "#212B36"  className={`searchBtn_Level`}
            onClick={loadParent}
            disabled={myUser && props.treeData && myUser.id==props.treeData.id}
          >
            Up 1 Level
          </Button>
        </div>
      </div>
      {/* <div className={`descRoot`}>
        <div className={`descBox`}>
          <div className={`descTextRoot`}>
            <div className={`descTextIcon userType1Color`} 
            />
            Affiliate
          </div> 
          <div className={`descTextRoot`}>
            <div className={`descTextIcon userType2Color`} 
            />
            Customer
          </div> 
        </div>
        <div className={`descBox`}>
          <div className={`descTextRoot`}>
            <div className={`descTextIcon userStatusAColor`} 
            />
            Active
          </div> 
          <div className={`descTextRoot`}>
            <div className={`descTextIcon userStatusIColor`} 
            />
            Inactive
          </div> 
          <div className={`descTextRoot`}>
            <div className={`descTextIcon userStatusHColor`} 
            />
            Hold
          </div> 
        </div>
      </div> */}
    </Wrapper>
  )
}
